import { useMutation } from "@apollo/client";
import { parseError } from "apollo";
import { Alert } from "components/base/Toast";
import { useEffect, useRef, useState } from "react";
import { SAVE_GTM_PROJECT } from "./graphql";

const useSaveGTMProject = (id, dataKey, initialState, timetout = 500) => {
  const [state, setState] = useState(initialState || {});
  const serializedInitialState = JSON.stringify(initialState || {});
  const [saveGTMProject, { loading }] = useMutation(SAVE_GTM_PROJECT, {
    onError(error) {
      Alert("error", parseError(error));
    },
    onCompleted() {
      Alert("success", "Project saved successfully!");
    },
  });

  const timer = useRef(null);

  function onChange(key, value, debounceSave = true) {
    const newValue = { ...state, [key]: value };
    setState(newValue);
    if (debounceSave) {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => save(newValue), timetout);
    } else {
      save(newValue);
    }
  }

  function applyValues(values, debounceSave = true) {
    const newValue = { ...state, ...values };
    setState(newValue);
    if (debounceSave) {
      if (timer.current) clearTimeout(timer.current);
      timer.current = setTimeout(() => save(newValue), timetout);
    } else {
      save(newValue);
    }
  }

  function setValues(values) {
    setState(values || {});
  }

  function save(newValue) {
    saveGTMProject({
      variables: {
        id,
        input: {
          [dataKey]: JSON.stringify(newValue, " ", 2),
        },
      },
    });
  }

  useEffect(() => {
    setState(initialState || {});
  }, [serializedInitialState]);

  useEffect(
    () => () => {
      if (timer.current) clearTimeout(timer.current);
    },
    [],
  );

  return { state, onChange, applyValues, setValues, loading };
};

export default useSaveGTMProject;
